import _ from 'lodash'

import config from '../../../../../../config'

import { GET_EXPORT, GET_EXPORT_REQUEST } from './constants'

export function getExport(module, id, type, outputName = null, params = {}) {
    return {
        type: GET_EXPORT,
        data: {
            module,
            id,
            type,
            outputName,
            params,
        },
    }
}

function getPortfolioExportRequest(groupId, type, lang, token, params) {
    const body = _.get(params, 'body', {})

    return {
        type: GET_EXPORT_REQUEST(config.modules.portfolio.key, groupId, type),
        payload: {
            ...config.api.portfolioExport,
            qs: {
                groupId,
                type,
                lang,
                token,
            },
            body,
        },
    }
}

function getReportExportRequest(entId, type, lang, token, params) {
    const body = _.get(params, 'body', {})
    const qs = _.get(params, 'qs', {})

    return {
        type: GET_EXPORT_REQUEST(config.modules.report.key, entId, type),
        payload: {
            ...config.api.reportExport[type],
            headers: {
                accept: `application/${type}`,
            },
            uriParams: {
                entId,
            },
            qs: {
                lang,
                ...qs,
                token,
            },
            body,
        },
    }
}

export const getExportRequest = {
    [config.modules.report.key]: getReportExportRequest,
    [config.modules.portfolio.key]: getPortfolioExportRequest,
}
